// Round back arrow, used at the top-left of screens instead of a "← Home" text
// button. 44px so it's an easy thumb target.
export function BackButton({ onClick, label = 'Back', style }: { onClick: () => void; label?: string; style?: React.CSSProperties }) {
  return (
    <button className="back-btn" onClick={onClick} aria-label={label} style={style}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M15 5l-7 7 7 7" />
      </svg>
    </button>
  );
}
